<section class="row vote">
  <div class="col-9 col-lg-5 offset-lg-1">
    <header class="bg-primary text-light vote__header">
      <h2 class="p-4">{{ title ?? ('stemmen-default-titel' | fromDictionary) }}</h2>
    </header>
  </div>
  <div class="mt-5 col-10 offset-2 col-sm-9 offset-sm-3 col-lg-4 offset-lg-0">
    <div class="lh-sm h5 ps-lg-5" *ngIf="!isVoted">
      <span *ngIf="count" class="fw-bold d-inline-block font-secondary text-secondary type-body-lg">
        <ng-container *ngIf="count === 1">{{ count + ' ' + ('stemmen-default-subtitel-enkelvoud' | fromDictionary) }}</ng-container>
        <ng-container *ngIf="count > 1">{{ count + ' ' + ('stemmen-default-subtitel' | fromDictionary) }}</ng-container>
      </span>
      <p class="fw-bold font-secondary text-primary">{{ text || ('stemmen-default-text' | fromDictionary) }}</p>
      <button class="button button--primary mt-3" (click)="vote.emit()">
        <span>{{ likeButtonLabel || ('stemmen-default-knop-label' | fromDictionary) }}</span>
        <app-icon anchor="icon-thumbs-up"></app-icon>
      </button>
    </div>

    <section class="p-4 ms-lg-2 bg-secondary text-light vote__valid" *ngIf="isVoted">
      <h3 class="mb-3">
        {{ resultTitle || ('stemmen-default-resultaat-titel' | fromDictionary) }}
        <app-icon anchor="icon-thumbs-up" class="icon-light"></app-icon>
      </h3>
      <div class="bg-light p-3 d-flex vote__result__text">
        <div class="vote__result__text__col">
          <p class="h3 text-primary">{{ count }}</p>
          <app-icon anchor="icon-thumbs-up" class="icon-primary icon-lg"></app-icon>
        </div>
        <div class="fw-bold text-primary lh-s1 ms-4">
          <p class="mb-0 type-body-lg">
            <ng-container *ngIf="count === 1">
              {{ resultText || ('stemmen-default-resultaat-tekst-enkelvoud' | fromDictionary) }}
            </ng-container>
            <ng-container *ngIf="count! > 1">{{ resultText || ('stemmen-default-resultaat-tekst' | fromDictionary) }}</ng-container>
          </p>
        </div>
      </div>
    </section>
  </div>
</section>
